import React from "react";

// Components
import Button from "components/Button";

// Libs
import { toast } from "react-toastify";

// Services
import DashboardService from "services/dashboard";

// Context
import { useGeneralProvider } from "contexts/general";

// Imgs
import CloseIconSvg from "assets/close-icon.svg";

import {
  BackDrop,
  Container,
  ImageWrapper,
  CloseIcon,
  Header,
  HeaderText,
  FooterContainer,
} from "./styles";

function ModalConfirmUpdate({
  setShowModal,
  companyId,
  anydeskId,
  handleCleanFilters,
}) {
  const { setLoading, globalUser } = useGeneralProvider();
  const userPassService = new DashboardService(globalUser);

  const handleUpdateCompanyAnydesk = () => {
    setLoading(true);

    userPassService
      .updateCompanyAnydeskStatus({
        companyId: companyId,
        anydeskId: anydeskId,
        status: false,
      })
      .then(() => {
        toast.success("Anydesk inativado com sucesso!");
        handleCleanFilters();
        setShowModal(false);
      })
      .catch((err) => {
        setLoading(false);

        if (err?.response?.data?.message) {
          toast.error(err.response.data.message);
        } else {
          toast.error("Falha ao inativar anydesk");
        }
      });
  };

  return (
    <BackDrop>
      <Container>
        <Header>
          <ImageWrapper />
          <HeaderText>Deseja inativar este anydesk?</HeaderText>
          <ImageWrapper onClick={() => setShowModal(false)}>
            <CloseIcon src={CloseIconSvg} />
          </ImageWrapper>
        </Header>
        <FooterContainer>
          <Button label="Confirmar" onClick={handleUpdateCompanyAnydesk} />
        </FooterContainer>
      </Container>
    </BackDrop>
  );
}

export default ModalConfirmUpdate;
